import { getCurrentSubdomain } from "utils/helpers";
import vars from "utils/vars";

export const postDocumentsUpload = ({ body = {}, options = null }) => {
	// Use fetch for absolute URL since it's external to base API
	const formData = body instanceof FormData ? body : new FormData();

	const justmedsBaseUrl = process.env.REACT_APP_JUSTMEDS_API_BASE_URL || "https://secure.justmeds.ca";
	// const justmedsBaseUrl = process.env.REACT_APP_JUSTMEDS_API_BASE_URL || "https://staging.justmeds.ca"; ---- develop

	// Get tenant for multi-tenant header (required by backend)
	const localhostFallbackTenant =
		!vars.isProduction && vars.app.allowLocalHostToMultiTenantDomains
			? vars.app.localSubdomain || vars?.patients?.tenantName || vars?.justmeds?.tenantName
			: null;

	const tenant =
		options?.headers?.Tenant ||
		options?.headers?.tenant ||
		vars.api.headers?.Tenant ||
		vars.api.headers?.tenant ||
		getCurrentSubdomain() ||
		localhostFallbackTenant;

	// Get auth token for Authorization header
	const tokenKey = vars?.localStorage?.fieldsName?.token || "token";
	const token = typeof window !== "undefined" ? window?.localStorage?.getItem(tokenKey) : null;
	const authHeader = token ? `Bearer ${token}` : null;

	// Prepare headers (merge with any existing headers from options)
	// Note: Don't set Content-Type for FormData - fetch will set it automatically with boundary
	const headers = {
		...(options?.headers || {}),
		...(tenant ? { Tenant: tenant } : {}),
		...(authHeader ? { Authorization: authHeader } : {}),
	};

	// Remove Content-Type if present to let fetch set it automatically for FormData
	delete headers["Content-Type"];
	delete headers["content-type"];

	// Extract options without headers to avoid conflicts
	const { headers: _ignoredHeaders, ...restOptions } = options || {};

	return fetch(`${justmedsBaseUrl}/api/taptype/documents`, {
		method: "POST",
		body: formData,
		headers,
		...restOptions,
	})
		.then(async (response) => {
			// Parse response to make it compatible with apiHandler
			const data = await response.json().catch(() => ({}));

			// Handle HTTP error status codes
			if (!response.ok) {
				const httpError = new Error(data.message || response.statusText || "Request failed");
				httpError.response = {
					data: data || { message: response.statusText || "Request failed" },
					status: response.status,
					statusText: response.statusText,
				};
				throw httpError;
			}

			// Return axios-like response structure for apiHandler compatibility
			return {
				data,
				status: response.status,
				statusText: response.statusText,
				headers: response.headers,
				config: {},
			};
		})
		.catch((error) => {
			// If error already has response property (HTTP error), re-throw as-is
			if (error.response) {
				throw error;
			}

			// Convert network/fetch errors to axios-like error structure
			const networkError = new Error(error.message || "Network error");
			networkError.response = {
				data: { message: error.message || "Network error" },
				status: 0,
				statusText: "Network Error",
			};
			throw networkError;
		});
};
